import WhatsApp from "./pages/WhatsApp";
import "bootstrap/dist/css/bootstrap.min.css";

function App() {
  return <WhatsApp />;
}

export default App;
